
import React , { useEffect }  from 'react';
import { Cell, Legend, Pie, PieChart } from "recharts";
import { COLORS } from "../../../componentObjects";
import PieChartCard from "../../InternalTriageAlerts/PieChartCard";

function CustomersCancellation(props) {
    const { customerCount ,feedbackData } = props;

    const activeCount = customerCount ? customerCount : 0;
    const inActiveCount = feedbackData?.length ? feedbackData?.length : 0;
 

    const data1 = [
        { Count: activeCount, customerType: "Active Customers" },
        { Count: inActiveCount, customerType: "Cancelled Customers" }
    ];

    useEffect(() => {
    }, [customerCount, feedbackData]);

    const mIndex = -1;
    const customerPicker = null;

    let customersChart =
        <div className={"justify-content-center display-flex"}>
            <PieChart width={400} height={300}>
                <Pie
                    data={data1}
                    innerRadius={40}
                    outerRadius={70}
                    fill="#8884d8"
                    paddingAngle={5}
                    dataKey="Count"
                    nameKey="customerType"
                    opacity="65%"
                    label={true}
                    isAnimationActive={false}
                >
                    {data1.map((_, index) => (
                        <Cell key={`cell-${index}`}
                              fill={COLORS[index % COLORS.length]}
                              stroke={mIndex === index ? '#333' : 'none'}
                              strokeWidth={mIndex === index ? 2 : 0}/>
                    ))}
                </Pie>
                <Legend verticalAlign="bottom" iconType="circle" iconSize={6}
                        wrapperStyle={{opacity: '75%', padding: '0px 10px'}}
                        formatter={(value, entry, index) => {
                            const activeStyle = {
                                fontWeight: mIndex === index ? 'bold' : 'normal',
                                color: mIndex === index ? COLORS[index % COLORS.length] : 'inherit'
                            };
                            return <span style={activeStyle}>{value}</span>;
                        }}
                />
            </PieChart>
        </div>;

    return (
        <div>
            <PieChartCard title={"Total Customers"} pieChartContent={customersChart} bottomContent={customerPicker} height={325} />
        </div>
    );
}

export default CustomersCancellation;